module.exports = __webpack_public_path__ + "static/media/logo-simples.a95634a8.svg";